import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from "react";
import { pushFormSubmitSuccess } from "@/components/client/Datalayer/utilities";
interface UseMarketoParams {
  formId: string;
  marketoDomain?: string;
  marketoInstance?: string;
  followUpUrl?: string | null;
  onSuccessCallback?: (formValues: Record<string, any>) => void;
  onTrackFormSubmit?: () => void;
}
declare global {
  interface Window {
    MktoForms2: any;
  }
}
const useMarketo = t0 => {
  const $ = _c(14);
  const {
    formId,
    marketoDomain,
    marketoInstance,
    followUpUrl,
    onSuccessCallback,
    onTrackFormSubmit
  } = t0;
  const [scriptAdded, setScriptAdded] = useState(false);
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const getUTMParams = _temp;
  let t1;
  if ($[0] !== followUpUrl || $[1] !== formId || $[2] !== marketoDomain || $[3] !== marketoInstance || $[4] !== onSuccessCallback || $[5] !== onTrackFormSubmit) {
    t1 = () => {
      if (!window.MktoForms2 || !marketoDomain || !marketoInstance) {
        return;
      }
      const numericId = parseInt(formId, 10);
      window.MktoForms2.loadForm(marketoDomain.startsWith("//") || marketoDomain.startsWith("http") ? marketoDomain : `//${marketoDomain}`, marketoInstance, numericId, form => {
        const utmParams_0 = getUTMParams();
        const hiddenFields = {
          ...utmParams_0,
          referrerUrl: `${window.location.hostname}${window.location.pathname}`,
          previousUrl: localStorage.getItem("previous_path") || document.referrer
        };
        form.addHiddenFields(hiddenFields);
        const syncFieldLabel = _temp2;
        const attachFieldListeners = field_0 => {
          syncFieldLabel(field_0);
          field_0.addEventListener("input", () => syncFieldLabel(field_0));
          field_0.addEventListener("change", () => syncFieldLabel(field_0));
        };
        setTimeout(() => {
          const formEl = document.getElementById(`mktoForm_${formId}`);
          if (!formEl) {
            return;
          }
          formEl.querySelectorAll(".mktoField").forEach(attachFieldListeners);
          const observer = new MutationObserver(() => {
            formEl.querySelectorAll(".mktoField").forEach(field_1 => {
              if (!(field_1 as any).__mktoSynced) {
                (field_1 as any).__mktoSynced = true;
                attachFieldListeners(field_1);
              }
            });
          });
          observer.observe(formEl, {
            childList: true,
            subtree: true
          });
        }, 150);
        form.onSuccess(values => {
          onTrackFormSubmit?.();
          pushFormSubmitSuccess({
            formName: formId,
            formType: "marketo_form",
            formProvider: "Marketo",
            formId,
            formData: values,
            utmParams: utmParams_0
          });
          if (followUpUrl) {
            window.location.href = followUpUrl;
            return false;
          }
          onSuccessCallback?.({
            ...values,
            ...utmParams_0
          });
          return false;
        });
      });
    };
    $[0] = followUpUrl;
    $[1] = formId;
    $[2] = marketoDomain;
    $[3] = marketoInstance;
    $[4] = onSuccessCallback;
    $[5] = onTrackFormSubmit;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const handleScriptLoad = t1;
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function stripMarketoDefaultStyles() {
      if (!document.getElementById("mktoForms2BaseStyle")) {
        const base = document.createElement("style");
        base.id = "mktoForms2BaseStyle";
        document.head.appendChild(base);
      }
      if (!document.getElementById("mktoForms2ThemeStyle")) {
        const theme = document.createElement("style");
        theme.id = "mktoForms2ThemeStyle";
        document.head.appendChild(theme);
      }
    };
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const stripMarketoDefaultStyles = t2;
  let t3;
  let t4;
  if ($[8] !== handleScriptLoad || $[9] !== marketoDomain || $[10] !== scriptAdded || $[11] !== scriptLoaded) {
    t3 = () => {
      if (!marketoDomain) {
        return;
      }
      stripMarketoDefaultStyles();
      if (scriptAdded) {
        if (!scriptLoaded) {
          handleScriptLoad();
          setScriptLoaded(true);
        }
      } else {
        if (window.MktoForms2) {
          setScriptAdded(true);
        } else {
          const baseUrl = marketoDomain.startsWith("//") || marketoDomain.startsWith("http") ? marketoDomain : `//${marketoDomain}`;
          const script = document.createElement("script");
          script.defer = true;
          script.src = `${baseUrl}/js/forms2/js/forms2.min.js`;
          document.head.appendChild(script);
          script.onload = () => {
            setScriptAdded(true);
          };
        }
      }
    };
    t4 = [handleScriptLoad, marketoDomain, scriptAdded, scriptLoaded];
    $[8] = handleScriptLoad;
    $[9] = marketoDomain;
    $[10] = scriptAdded;
    $[11] = scriptLoaded;
    $[12] = t3;
    $[13] = t4;
  } else {
    t3 = $[12];
    t4 = $[13];
  }
  useEffect(t3, t4);
};
export default useMarketo;
function _temp() {
  const utmParams = {};
  const utmKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
  utmKeys.forEach(key => {
    utmParams[key] = localStorage.getItem(key) || new URLSearchParams(window.location.search).get(key);
  });
  return utmParams;
}
function _temp2(field) {
  const wrap = field.closest(".mktoFieldWrap");
  if (!wrap) {
    return;
  }
  const el = field as HTMLInputElement | HTMLSelectElement;
  const isEmpty = el.value === "" || el.value === "Select..." || el.value === undefined;
  wrap.classList.toggle("has-value", !isEmpty);
}